export default __webpack_public_path__ + "static/media/realestatesolutions.ae932b45.webp";